/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const personIndexDataLastActivitySchema = z.enum(['anytime', 'last_24h', 'last_7d', 'last_30d'])

export type PersonIndexDataLastActivitySchema = z.infer<typeof personIndexDataLastActivitySchema>
